import React from "react";
import PropTypes from "prop-types";
import { v4 as uuid } from "uuid";
import { LoaderDots, Empty } from "./loaders";

function SimpleMapper({
  elements,
  loading,
  emptyMessage,
  component,
  componentAditionalProps,
  classNameContainer,
}) {
  let content;

  if (loading) {
    content = <LoaderDots />;
  } else if (elements.length > 0) {
    const ComponentToRender = component;
    content = elements
      .filter((e) => !e.deleted)
      .map((item) => (
        <ComponentToRender
          key={uuid()}
          element={item}
          {...componentAditionalProps}
        />
      ));
    if (classNameContainer) {
      content = <div className={classNameContainer}>{content}</div>;
    }
  } else {
    content = <Empty message={emptyMessage} />;
  }

  return content;
}

SimpleMapper.propTypes = {
  elements: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  emptyMessage: PropTypes.string,
  component: PropTypes.any,
  componentAditionalProps: PropTypes.object,
  classNameContainer: PropTypes.string,
};

SimpleMapper.defaultProps = {
  elements: [],
  loading: false,
  componentAditionalProps: {},
};

export { SimpleMapper };
